<template>
  <div
    id="sidebar"
    class="tw-h-screen tw-hidden xl:tw-inline-block tw-z-10"
  >
    <div
      class="sidebar-container tw-fixed tw-h-screen tw-flex tw-flex-col tw-bg-white tw-border-r tw-border-[#E2E8F0]"
      :style="{ overflowY: 'auto' }"
    >
      <!-- Logo -->
      <div class="tw-px-6 tw-pt-6 tw-pb-8">
        <img
          src="@/assets/img/logo-icon.svg"
          class="tw-cursor-pointer tw-h-8"
          alt="getEquity"
          @click="homePage"
        />
      </div>

      <!-- Navigation -->
      <nav class="tw-flex-1 tw-px-3">
        <div class="tw-space-y-1">
          <SidebarMenu
            title="Overview"
            href="/dashboard/overview"
            :focus="overviewFocus || $route.path.includes('/dashboard/overview')"
          />

          <SidebarMenu
            v-if="hasPermission('deal:*')"
            title="Deals"
            href="/dashboard/deals"
            :focus="dealsFocus || $route.path.includes('/dashboard/deals')"
          />

          <SidebarMenu
            v-if="hasPermission('spv:*')"
            title="SPVs"
            href="/dashboard/spv"
            :focus="spvFocus || $route.path.includes('/dashboard/spv')"
          />

          <SidebarMenu
            v-if="hasPermission('invest:*')"
            title="Invest"
            :children="investPages"
            :focus="investFocus || $route.path.includes('/dashboard/invest')"
          />

          <SidebarMenu
            v-if="hasPermission('wallet:*') && hasPermission('bank:*')"
            title="Wallet"
            href="/dashboard/wallet"
            :focus="walletFocus || $route.path.includes('/dashboard/wallets')"
          />

          <SidebarMenu
            v-if="hasPermission('member:*')"
            title="Members"
            href="/dashboard/members"
            :focus="membersFocus || $route.path.includes('/dashboard/members')"
          />

          <SidebarMenu
            v-if="hasPermission('team:*')"
            title="Teams"
            href="/dashboard/teams"
            :focus="teamsFocus || $route.path.includes('/dashboard/teams')"
          />

          <SidebarMenu
            title="Account"
            href="/dashboard/account"
            :focus="accountFocus || $route.path.includes('/dashboard/account')"
          />

          <SidebarMenu
            v-if="hasPermission('api:*')"
            title="API"
            href="/dashboard/api-client"
            :focus="apiFocus || $route.path.includes('/dashboard/api-client')"
          />
        </div>
      </nav>

      <!-- Help section -->
      <!-- <div class="tw-px-3 tw-pb-6 tw-mt-auto">
        <a 
          href="/faqs" 
          class="tw-flex tw-items-center tw-gap-4 tw-px-4 tw-py-3 tw-rounded-xl tw-text-[#64748B] hover:tw-bg-[#F1F5F9] hover:tw-text-[#334155] tw-transition-colors tw-duration-200"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
          <span class="tw-text-sm tw-font-medium">Help & Support</span>
        </a>
      </div> -->
    </div>
  </div>
</template>

<script>
import SidebarMenu from "@/components/navigation/SidebarMenu.vue";
import { getItem } from "@/utils/storage";

export default {
  name: "Sidebar",

  components: { SidebarMenu },

  data() {
    return {
      // Invest is one area with four views. The header only toggles; Overview is an explicit
      // child so there is never a question of what clicking the parent does.
      investPages: [
        { title: "Overview", href: "/dashboard/invest" },
        { title: "Opportunities", href: "/dashboard/invest/opportunities" },
        { title: "My Investments", href: "/dashboard/invest/investments" },
        { title: "GetEquity Exchange", href: "/dashboard/invest/exchange" },
      ],
      overviewFocus: false,
      dealsFocus: false,
      spvFocus: false,
      walletFocus: false,
      membersFocus: false,
      teamsFocus: false,
      accountFocus: false,
      apiFocus: false,
      investFocus: false,
      userPermissions: [],
    };
  },

  created() {
    this.setFocus(this.$route.name);
    this.loadUserPermissions();
  },

  methods: {
    homePage() {
      this.$router.push("/");
    },

    faqPage() {
      this.$router.push("/faqs");
    },

    setFocus(route) {
      this.overviewFocus = false;
      this.dealsFocus = false;
      this.spvFocus = false;
      this.walletFocus = false;
      this.membersFocus = false;
      this.teamsFocus = false;
      this.accountFocus = false;
      this.investFocus = false;
      this.apiFocus = false;
      switch (route) {
        case "OverviewDetails":
          this.overviewFocus = true;
          break;
        case "Deals":
          this.dealsFocus = true;
          break;
        case "DealInfo":
          this.dealsFocus = true;
          break;
        case "CreateDeal":
          this.dealsFocus = true;
          break;
        case "CreateAsset":
          this.dealsFocus = true;
          break;
        case "SPVs":
          this.spvFocus = true;
          break;
        case "Invest":
          this.investFocus = true;
          break;
        case "Trade":
          this.investFocus = true;
          break;
        case "TokenTrade":
          this.investFocus = true;
          break;
        case "InvestOrderbook":
          this.investFocus = true;
          break;
        case "TokenUpdates":
          this.investFocus = true;
          break;
        case "Wallet":
          this.walletFocus = true;
          break;
        case "Members":
          this.membersFocus = true;
          break;
        case "Teams":
          this.teamsFocus = true;
          break;
        case "Account":
          this.accountFocus = true;
          break;
        case "ApiClient":
          this.apiFocus = true;
          break;
        case "ResetPassword":
          this.accountFocus = true;
          break;

        default:
          break;
      }
    },

    loadUserPermissions() {
      const teamMember = getItem("team_member");

      if (teamMember) {
        const parsedPermissions = teamMember.groups[0].permissions[0];

        console.log(parsedPermissions, "parsed");
        try {
          if (parsedPermissions) {
            if (parsedPermissions && parsedPermissions?.actions) {
              this.userPermissions = parsedPermissions?.actions;
            }
          }
        } catch (error) {
          console.error("Error parsing permissions:", error);
        }
      }
    },

    hasPermission(permission) {
      if (!this.userPermissions || this.userPermissions.length === 0) {
        return true;
      }

      if (permission.endsWith("*")) {
        const prefix = permission.slice(0, -1);
        return this.userPermissions.some((p) => p.startsWith(prefix));
      }

      return this.userPermissions.includes(permission);
    },
  },

  watch: {
    $route(to, from) {
      deep: true;
      immediate: true;
      if (to !== from) {
        this.setFocus(this.$route.name);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#sidebar {
  width: $side-bar-width;

  .sidebar-container {
    width: $side-bar-width;
    scrollbar-width: thin;
    scrollbar-color: #E2E8F0 transparent;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #E2E8F0;
      border-radius: 4px;
    }
  }
}
</style>
